import type { Attachment } from './types'
import type {
  LiquidDocument,
  LiquidExternalLinkDocument,
  LiquidExportDocument,
} from '@app/shared/types/sf-data'

import { DocumentLinkType } from '@app/shared/types/sf-data'

export const isExternalLink = (
  attachment: Attachment | LiquidDocument
): attachment is LiquidExternalLinkDocument => {
  return attachment.linkType === DocumentLinkType.ExternalLink
}

export const isExport = (
  attachment: Attachment | LiquidDocument
): attachment is LiquidExportDocument => {
  return attachment.linkType === DocumentLinkType.Export
}
